<template>
    <div>
        <h4>Login</h4>
        <div class="form">
            <label for="email">Nome utente</label>
            <div>
                <input id="username" type="text" v-model="username" required autofocus>
            </div>
            <div>
                <label for="password">Password</label>
                <div>
                    <input id="password" type="password" v-model="password" required>
                </div>
            </div>
            <div>
                <button type="submit" @click="login">
                    Entra
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import UsersService from '@/services/UsersService'
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    async login () {
      // console.log(this.$route)
      try {
          const response = await UsersService.login({
            username: this.username,
            password: this.password
          })
          // console.log(response)
          localStorage.setItem('username', JSON.stringify(response.data.username))
          localStorage.setItem('jwt', response.data.token)

          if (localStorage.getItem('jwt') != null) {
            this.$emit('loggedin', true)
            if (this.$route.params.nextUrl != null) {
              this.$router.push(this.$route.params.nextUrl)
            } else {
              this.$router.push('dashboard')
            }
          }
      } catch (err) {
        alert('Login errato')
      }
    }
  }
}

</script>
<style type="text/css">
.form input, .form textarea {
  width: 100%;
  max-width: 500px;
  padding: 10px;
  border: 1px solid #e0dede;
  outline: none;
  font-size: 12px;
}
.form div {
  margin: 20px;
}
button {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  max-width: 500px;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue